
export default {
  name: 'LoleVideoPicture',
  props: {
    url: {
      type: String,
      default: '',
    },
    sizeW: {
      type: [String, Number],
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    disabledAutoPlay: {
      type: Boolean,
      default: false,
    },
    logoPlayWhite: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVideoPlaying: true,
  }),
  mounted() {
    if (this.disabledAutoPlay) this.togglePlay()
  },
  methods: {
    async togglePlay() {
      if (!this.isVideoPlaying) {
        try {
          await this.$refs.productVideo.play()
          this.isVideoPlaying = true
        } catch (error) {
          this.$sentryException(error, {
            source: 'state',
            component: 'lole-video-picture',
            level: 'warning',
            extra: 'Failed to play product video',
          })
        }
        return
      }
      try {
        await this.$refs.productVideo.pause()
        this.isVideoPlaying = false
      } catch (error) {
        this.$sentryException(error, {
          source: 'state',
          component: 'lole-video-picture',
          level: 'warning',
          extra: 'Failed to pause product video',
        })
      }
    },
  },
}
